import axios from 'axios';
import i18n from '../i18n';

// === Detectar entorno dinámicamente ===
const isMobileEnv =
    typeof window !== "undefined" &&
    /mobile|android|iphone|ipad|ipod/i.test(navigator.userAgent);

// ✅ Ajusta tus URLs aquí
const BASE_URL_WEB = "https://api.luckypetz.ru";
const BASE_URL_MOBILE = "https://api.luckypetz.ru";

// const BASE_URL_WEB = "http://localhost:3000";
// const BASE_URL_MOBILE = "http://192.168.3.4:3000";

// Detecta base según entorno
export const BASE_URL = isMobileEnv ? BASE_URL_MOBILE : BASE_URL_WEB;

const api = axios.create({
    baseURL: BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Interceptor para agregar el token JWT a las cabeceras de cada request (si existe)
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        // Add locale param
        config.params = config.params || {};
        config.params.locale = i18n.language ? i18n.language.split('-')[0] : 'ru';

        return config;
    },
    (error) => Promise.reject(error)
);

api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            localStorage.removeItem('token');

            const currentPath = window.location.pathname;
            const publicPaths = ['/', '/login', '/register', '/verify-email', '/blog', '/reports', '/municipalities', '/posts'];
            const isPublic = publicPaths.some(p =>
                currentPath === p || currentPath.startsWith(p + '/')
            );

            const method = error.config?.method?.toLowerCase();
            const isMutation = ['post', 'put', 'delete', 'patch'].includes(method);

            // Evitar redirigir si el usuario ya está en login o register
            const isAuthPage = ['/login', '/register'].includes(currentPath);

            if ((!isPublic || isMutation) && !isAuthPage) {
                console.warn("[API] Redirecting to root due to 401");
                window.location.href = '/';
            }
        }
        return Promise.reject(error);
    }
);

export default api;